import { readPanelPreference } from './preference';

export interface UserPanelState {
    /** `type:id` declared by the current page, sent as `?uctx=` on open. */
    context: string | null;
    /** Id being opened; lets the panel show a skeleton before the partial reload lands. */
    pendingUserId: number | null;
    preference: boolean;
}

type Listener = () => void;

let state: UserPanelState = { context: null, pendingUserId: null, preference: readPanelPreference() };
const listeners = new Set<Listener>();

export function getUserPanelState(): UserPanelState {
    return state;
}

export function setUserPanelState(patch: Partial<UserPanelState>): void {
    state = { ...state, ...patch };
    listeners.forEach((listener) => listener());
}

export function subscribeUserPanel(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
